export default __webpack_public_path__ + "images/f152e84c1d22cd0c1a862058fc20c677-washington_dc_mobile.webp";